import {
  customScrollMinimal,
  SmartTable,
  typographyV2,
} from '@toggle/design-system';
import styled, { css } from 'styled-components';

export const Root = styled.div<{ $hasTitle: boolean; $isSmallTitle: boolean }>`
  display: flex;
  flex-direction: column;
  gap: ${({ $hasTitle, $isSmallTitle }) =>
    $hasTitle ? ($isSmallTitle ? '4px' : '8px') : '0px'};
  width: 100%;
`;

export const SmartTableWrapper = styled.div<{ $noCellPadding: boolean }>`
  overflow-x: auto;
  ${customScrollMinimal};

  ${SmartTable.Styled.Table} {
    thead tr th {
      border-bottom: 1px solid var(--border-default);
      white-space: pre-wrap;
      padding: 4px 8px;
    }

    th,
    td {
      background-color: var(--background-soft);
    }

    td {
      ${({ $noCellPadding }) =>
        $noCellPadding &&
        css`
          padding: 0;
        `}
    }
  }
`;

export const TitleWrapper = styled.div<{ $isSmallTitle: boolean }>`
  ${({ $isSmallTitle }) =>
    $isSmallTitle
      ? css`
          ${typographyV2.titleSm};
          color: var(--text-soft);
        `
      : css`
          ${typographyV2.titleMd};
        `}
`;
